import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import ErrorBoundary from "./ErrorBoundary.jsx";
import Root from "./Root.jsx";
import { installNumberInputGuard } from "./lib/number-input.js";
import { applyTextScale } from "./lib/textScale.js";
import { registerServiceWorker } from "./lib/serviceWorker.js";

installNumberInputGuard();
// גודל הטקסט שנבחר בהגדרות — מוחל לפני הרינדור הראשון, בלי הבהוב.
applyTextScale();
registerServiceWorker();

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Root />
    </ErrorBoundary>
  </React.StrictMode>,
);
